export default {"src":"/_next/static/media/2D-front.10386668.svg","height":30,"width":21};